export const IPushNotificationsRepositoryType = Symbol('IPushNotificationsRepository');
